import React from 'react';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import LaunchIcon from '@material-ui/icons/Launch';
import BarChart from '../users/BarChart';
import Badge from '@material-ui/core/Badge';
const styles = {
  main: { display: 'flex', flexWrap: 'wrap' },
  chip: { margin: 4, background: 'none' },
  icon: { width: '0.5em', paddingLeft: 2 },
  spacing: { paddingTop: '10px', textAlign: 'right' }
};

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: '580px',
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9'
  }
}))(Tooltip);

const GamesField = ({ record, translate }) => (
  <span style={styles.main}>
    <Chip
      key={record.number_of_games_created}
      style={styles.chip}
      label={
        <HtmlTooltip
          title={
            <React.Fragment>
              <div style={styles.spacing}>
                <Typography variant="body2" component="p" color="inherit">
                  Total
                </Typography>
                <Typography variant="h1" component="h1" gutterBottom>
                  {record.number_of_games_created}
                </Typography>
              </div>

              <BarChart record={record} />
              <Typography variant="body2" component="p" color="inherit">
                {'Created Games detailed chart'}
              </Typography>
              <em>
                {
                  'Note: Shared by colleague might have been counted in other figures'
                }
              </em>
            </React.Fragment>
          }
        >
          <Button icon={<LaunchIcon />}>
            {record.number_of_games_created}
            <LaunchIcon style={styles.icon} />
          </Button>
        </HtmlTooltip>
      }
    />
  </span>
);

GamesField.defaultProps = {
  addLabel: true,
  source: 'number_of_games_created'
};

export default GamesField;



// WEBPACK FOOTER //
// ./src/users/GamesField.js